<template>
	<Autocomplete
		v-model="model"
		:icon="icon"
		:label="label"
		:name="name"
		display-name="component.accounts.accountingYear"
		:endpoint="endpoint"
		:min-width="180"
		data-test="accounting_years-autocomplete"
		:item-title="
			(item: Api.AccountingYear) => {
				return $vuetify.display.mdAndUp || multiple
					? `${item.year} - ${formatDate(item.started_at)} - ${formatDate(item.ended_at)}`
					: `${item.year}`
			}
		"
		:multiple="multiple"
		v-bind="$attrs"
		ref="autocompleteRef"
		:params="{
			od: 'DESC',
			of: 'year',
		}"
	>
		<template #item="{ item, props }">
			<v-list-item
				v-bind="props"
				:title="`${item.raw.year}`"
				:subtitle="`${formatDate(item.raw.started_at)} - ${formatDate(item.raw.ended_at)}`"
			>
			</v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'
import { useDayJs } from '@/composables/dateTime'
import { computed, onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'

const {
	icon = '$accountYearDefault',
	label = 'component.accounts.accountingYear',
	name = 'accountingyears',
	multiple = false,
} = defineProps<{
	icon?: string
	label?: string
	name?: string
	multiple?: boolean
}>()

const model = defineModel<Api.AccountingYear[] | Api.AccountingYear>()
const endpoint = ref('accounting_years')
const autocompleteRef = ref<InstanceType<typeof Autocomplete> | null>(null)
const router = useRouter()

onBeforeMount(() => {
	if (
		router.currentRoute.value.matched.find((r) => r.meta.name === 'building')
	) {
		endpoint.value = `buildings/${router.currentRoute.value.params.id}/accounting_years`
	}
})

const { getLocalDate } = useDayJs()
const formatDate = (dateStr: string) => getLocalDate(dateStr) ?? '-'

// Re-expose the properties as computed properties
defineExpose({
	itemsTotal: computed(() => autocompleteRef.value?.itemsTotal),
	reload: () => autocompleteRef.value?.reload(),
	loading: computed(() => autocompleteRef.value?.loading),
})
</script>

<style scoped></style>
